import { Drawer } from "antd";
import React from "react";
import DashboardSideBar from "./DashboardSideBar";

interface DashboardSideBarDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  dashboardRef: React.RefObject<HTMLDivElement> | null;
  handleBookSession: () => void;
}

const DashboardSideBarDrawer: React.FC<DashboardSideBarDrawerProps> = ({
  isOpen,
  onClose,
  dashboardRef,
  handleBookSession,
}) => {
  return (
    <Drawer
      open={isOpen}
      onClose={onClose}
      placement="left"
      getContainer={dashboardRef?.current || undefined}
      closeIcon={false}
    >
      <DashboardSideBar
        collapsed={false}
        isSidebarOpen={isOpen}
        handleBookSession={handleBookSession}
      />
    </Drawer>
  );
};

export default DashboardSideBarDrawer;
